import { restGet } from "apiCommandsExecutor/rest";

import { ClientsPageDto } from "./restModels";

// Клиенты заведения (REST /api/rest/warehouse/v1). Заведение бэк берёт из аккаунта;
// выборка отсортирована по дате последнего заказа, от свежих к старым.
export const getClients = (skip: number, limit: number) =>
    restGet<ClientsPageDto>("/clients", { skip, limit });
